import { Component, AfterViewInit, AfterContentInit } from '@angular/core';
import { SectionFormDirective } from '@app/classes/section-form.class';
import { FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: './summary-medical-appeal.component.html',
  styleUrls: ["./summary-medical-appeal.component.scss"],
  standalone: false
})

export class SummaryMedicalAppealComponent extends SectionFormDirective implements AfterContentInit, AfterViewInit {


  constructor(builder: FormBuilder,
    private titleService: Title,
    public translateService: TranslateService
  ) {
    super(builder)
    this.titleService.setTitle('Medical Appeal Request Summary');
  }

  defaultLanguage: string;
  translatedLang: string;
  MEDICAL_APPEAL_SUMMARY_STATIC1: string;
  MEDICAL_APPEAL_SUMMARY_STATIC1en = 'Medical Appeal Information Summary';
  MEDICAL_APPEAL_SUMMARY_STATIC1sp = 'Resumen de la información de la apelación médica';
  MEDICAL_APPEAL_SUMMARY_STATIC2: string;
  MEDICAL_APPEAL_SUMMARY_STATIC2en = 'Do you need to make a change before you submit? <b>Click the green check mark at the top of your screen for the section you want to change.</b>';
  MEDICAL_APPEAL_SUMMARY_STATIC2sp = '¿Necesita hacer un cambio antes de enviar? En la parte superior de la pantalla, haga clic en la marca de verificación verde de la sección que quiere cambiar.';
  MEDICAL_APPEAL_SUMMARY_STATIC3: string;
  MEDICAL_APPEAL_SUMMARY_STATIC3en = 'Medical Appeal Request Information';
  MEDICAL_APPEAL_SUMMARY_STATIC3sp = 'Información para la petición de apelación médica';
  MEDICAL_APPEAL_SUMMARY_STATIC4: string;
  MEDICAL_APPEAL_SUMMARY_STATIC4en = 'Below is the information you told us about who this appeal is for and the person filing this medical appeal request.';
  MEDICAL_APPEAL_SUMMARY_STATIC4sp = 'A continuación se muestra la información que nos proporcionó sobre a quién corresponde esta apelación y la persona que presenta esta petición de apelación médica.';
  MEDICAL_APPEAL_SUMMARY_STATIC5: string;
  MEDICAL_APPEAL_SUMMARY_STATIC5en = 'Medical Appeal Request Details';
  MEDICAL_APPEAL_SUMMARY_STATIC5sp = 'Detalles de la petición de apelación médica';
  MEDICAL_APPEAL_SUMMARY_STATIC6: string;
  MEDICAL_APPEAL_SUMMARY_STATIC6en = 'Below is the information you told us about this medical appeal request.';
  MEDICAL_APPEAL_SUMMARY_STATIC6sp = 'A continuación se muestra la información que nos proporcionó sobre esta petición de apelación médica.';
  MEDICAL_APPEAL_SUMMARY_STATIC7: string;
  MEDICAL_APPEAL_SUMMARY_STATIC7en = 'Member Demographics';
  MEDICAL_APPEAL_SUMMARY_STATIC7sp = 'Datos demográficos del miembro';
  MEDICAL_APPEAL_SUMMARY_STATIC8: string;
  MEDICAL_APPEAL_SUMMARY_STATIC8en = 'Below is the information you told us about the member this medical appeal request is for.';
  MEDICAL_APPEAL_SUMMARY_STATIC8sp = 'A continuación se muestra la información que nos proporcionó sobre el miembro para quien se presenta esta petición de apelación médica.';

  data: any;
  medicalAppealRequestInformationArray: any = [];
  mainInfoArray: any = [];
  filerContactArray: any = [];
  medicalAppealDetailsArray: any = [];
  medicalAppealDemographicsArray: any = [];
  requestInfoNoTranslateArray = ['Household Member', 'Name', 'Phone Number','Address','Case Number'];
  demographicsNoTranslateArray = ['Primary Phone Number', 'Secondary Phone Number', 'Email Address','Household Member Address'];

  // editKey;
  // array;
  // array2;
  // coverageKey;

  ngAfterContentInit() {
    this.data = this.getValue('data');
    sessionStorage.removeItem('removedAppealRecord')
    this.medicalAppealRequestInformationArray = this.data?.medAplReqInfo?.medAplRequest?.request;
    this.medicalAppealDetailsArray = this.data?.medAplDetails?.medAplRequest?.request;
    this.medicalAppealDemographicsArray = this.data?.medAplDemographics?.medAplRequest?.request;
    this.formatPhoneNum();
    const whoFilingIdx = this.medicalAppealRequestInformationArray.findIndex(
      (item: any) => item.key?.includes('Who are you filing')
    );
    const mainEndIdx = whoFilingIdx >= 0 ? whoFilingIdx + 2 : this.medicalAppealRequestInformationArray.length;
    this.mainInfoArray = this.medicalAppealRequestInformationArray.slice(0, mainEndIdx);
    this.filerContactArray = this.medicalAppealRequestInformationArray.slice(mainEndIdx);
    // this.editKey = this.medicalAppealDetailsArray.findIndex(item => item.key.includes('You applied for benefits on'));
    // const string1 = this.medicalAppealDetailsArray[this.editKey]?.key;
    // this.array = string1?.split('on');
    // const string2 = this.array? this.array[1] : '';
    // this.array2 = string2?.split(',')

    // this.medicalAppealDetailsArray = this.medicalAppealDetailsArray.map(item => {
    //   if (item.key.includes('Coverage Type for ')) {
    //     item.name = item.key.replace('Coverage Type for', '');
    //     item.coverageKey = 'Coverage Type for';
    //   }
    //   return item;
    // });


    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.getLables(this.translatedLang);
    this.getDemographicMilitaryAddress(this.translatedLang);

    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.translatedLang = res.lang;
      this.getLables(this.translatedLang);
      this.getDemographicMilitaryAddress(this.translatedLang);
    })
  }

  
  formatPhoneNum() {
    this.medicalAppealRequestInformationArray = this.medicalAppealRequestInformationArray.map((item: any) => {
      if (item.key.includes('Phone Number') && item.value !== 'Not Applicable') {
        item.value = `(${item.value.substr(0, 3)}) ${item.value.substr(3, 3)}-${item.value.substr(6)}`;
      }
      return item;
    })
  }

  getDemographicMilitaryAddress(lang:string) {
    this.medicalAppealDemographicsArray = this.medicalAppealDemographicsArray.map((item:any) => {
      if (item.key === 'Appellant Address' && lang !== 'en') {
        if (item.value.includes('Air/Army Post Office')) {
          item.value = item.value.replace('Air/Army Post Office', 'Oficina de Correos de la Fuerza Aérea/Ejército')
        } if (item.value.includes('Fleet Post Office')) {
          item.value = item.value.replace('Fleet Post Office', 'Oficina de correos de la Flota')
        }
        if (item.value.includes('Armed Forces America')) {
          item.value = item.value.replace('Armed Forces America', 'Fuerzas Armadas de Estados Unidos')
        } else if (item.value.includes('Armed Forces Africa, Canada, Europe, Middle East')) {
          item.value = item.value.replace('Armed Forces Africa, Canada, Europe, Middle East', 'Fuerzas Armadas de ÿfrica, Canadá, Europa, Medio Oriente')
        } else if (item.value.includes('Armed Forces Pacific')) {
          item.value = item.value.replace('Armed Forces Pacific', 'Fuerzas Armadas del Pacífico')
        } else if (item.key.includes('Primary Phone Number')) {
          item.value = `(${item.value.substr(0, 3)}) ${item.value.substr(3, 3)}-${item.value.substr(6)}`;
        }
        else if (item.key.includes('Secondary Phone Number') && item.value !== 'Not Answered') {
          item.value = `(${item.value.substr(0, 3)}) ${item.value.substr(3, 3)}-${item.value.substr(6)}`;
        }

      } else {
        if (item.value.includes('Oficina de Correos de la Fuerza Aérea/Ejército')) {
          item.value = item.value.replace('Oficina de Correos de la Fuerza Aérea/Ejército', 'Air/Army Post Office')
        } if (item.value.includes('Oficina de correos de la Flota')) {
          item.value = item.value.replace('Oficina de correos de la Flota', 'Fleet Post Office')
        }
        if (item.value.includes('Fuerzas Armadas de Estados Unidos')) {
          item.value = item.value.replace('Fuerzas Armadas de Estados Unidos', 'Armed Forces America')
        } else if (item.value.includes('Fuerzas Armadas de ÿfrica, Canadá, Europa, Medio Orientet')) {
          item.value = item.value.replace('Fuerzas Armadas de ÿfrica, Canadá, Europa, Medio Orientet', 'Armed Forces Africa, Canada, Europe, Middle East')
        } else if (item.value.includes('Fuerzas Armadas del Pacífico')) {
          item.value = item.value.replace('Fuerzas Armadas del Pacífico', 'Armed Forces Pacific')
        } else if (item.key.includes('Primary Phone Number')) {
          item.value = `(${item.value.substr(0, 3)}) ${item.value.substr(3, 3)}-${item.value.substr(6)}`;
        }
        else if (item.key.includes('Secondary Phone Number') && item.value !== 'Not Answered') {
          item.value = `(${item.value.substr(0, 3)}) ${item.value.substr(3, 3)}-${item.value.substr(6)}`;
        }
      }
      return item;
    })
  }


  ngAfterViewInit() {
    super.ngAfterViewInit();
    const elementsList: NodeListOf<Element> = document.querySelectorAll(".carat");
    elementsList.forEach((i) => {
      document.getElementById(i.id).addEventListener("click", this.logInfo.bind(this));
      i.nextElementSibling?.addEventListener("click", this.logInfo.bind(this));
    });

    const elementList: NodeListOf<Element> = document.querySelectorAll("#accordion");
    var headings = elementList[0]?.querySelectorAll('[id^="caratId"]');
    for (let i = 0; i < headings.length; i++) {
      (headings[i] as any).onclick = this.logInfo;
    }
  }

  getLables(lang: string) {
    if (lang === 'en') {
      this.MEDICAL_APPEAL_SUMMARY_STATIC1 = this.MEDICAL_APPEAL_SUMMARY_STATIC1en;
      this.MEDICAL_APPEAL_SUMMARY_STATIC2 = this.MEDICAL_APPEAL_SUMMARY_STATIC2en;
      this.MEDICAL_APPEAL_SUMMARY_STATIC3 = this.MEDICAL_APPEAL_SUMMARY_STATIC3en;
      this.MEDICAL_APPEAL_SUMMARY_STATIC4 = this.MEDICAL_APPEAL_SUMMARY_STATIC4en;
      this.MEDICAL_APPEAL_SUMMARY_STATIC5 = this.MEDICAL_APPEAL_SUMMARY_STATIC5en;
      this.MEDICAL_APPEAL_SUMMARY_STATIC6 = this.MEDICAL_APPEAL_SUMMARY_STATIC6en;
      this.MEDICAL_APPEAL_SUMMARY_STATIC7 = this.MEDICAL_APPEAL_SUMMARY_STATIC7en;
      this.MEDICAL_APPEAL_SUMMARY_STATIC8 = this.MEDICAL_APPEAL_SUMMARY_STATIC8en;
    } else {
      this.MEDICAL_APPEAL_SUMMARY_STATIC1 = this.MEDICAL_APPEAL_SUMMARY_STATIC1sp;
      this.MEDICAL_APPEAL_SUMMARY_STATIC2 = this.MEDICAL_APPEAL_SUMMARY_STATIC2sp;
      this.MEDICAL_APPEAL_SUMMARY_STATIC3 = this.MEDICAL_APPEAL_SUMMARY_STATIC3sp;
      this.MEDICAL_APPEAL_SUMMARY_STATIC4 = this.MEDICAL_APPEAL_SUMMARY_STATIC4sp;
      this.MEDICAL_APPEAL_SUMMARY_STATIC5 = this.MEDICAL_APPEAL_SUMMARY_STATIC5sp;
      this.MEDICAL_APPEAL_SUMMARY_STATIC6 = this.MEDICAL_APPEAL_SUMMARY_STATIC6sp;
      this.MEDICAL_APPEAL_SUMMARY_STATIC7 = this.MEDICAL_APPEAL_SUMMARY_STATIC7sp;
      this.MEDICAL_APPEAL_SUMMARY_STATIC8 = this.MEDICAL_APPEAL_SUMMARY_STATIC8sp;
    }
  }

  logInfo(e: any) {
    const id = e.currentTarget.id.split("_");
    const el = document.getElementById("collapse_" + id[1]);
    el.classList.toggle("show");

    const up = document.getElementById("up_" + id[1]);
    up.classList.toggle("cla1");
    up.classList.toggle("cla2");

    const dwn = document.getElementById("dwn_" + id[1]);
    dwn.classList.toggle("cla2");
    dwn.classList.toggle("cla1");
  }

}